import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=21e1d0e0&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=21e1d0e0&prod&lang=less&"
import style1 from "./Loading.vue?vue&type=style&index=1&id=21e1d0e0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports